<template>
    <GenericConnectedIntegrationCard
        :integration="integration"
        :providerData="providerData"
        @onIntegrationDeleted="emits('onIntegrationDeleted')"
    >
        <template #actions>
            <OutlookCalendarIntegrationSettingsButtonDrawer
                :integration="integration"
                @onSuccess="emits('onIntegrationUpdated', $event)"
            />
        </template>
    </GenericConnectedIntegrationCard>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import { type IntegrationProviderDataType } from '@/Shared/AutoGenerated/Main'
    import GenericConnectedIntegrationCard from '@/App/Integration/Component/GenericConnectedIntegrationCard.vue'
    import OutlookCalendarIntegrationSettingsButtonDrawer from '@/App/Integration/Component/OutlookCalendarIntegrationSettingsButtonDrawer.vue'

    const emits = defineEmits<{
        onIntegrationDeleted: []
        onIntegrationUpdated: [{ integration: Integration }]
    }>()

    const props = defineProps({
        integration: {
            type: Object as PropType<Integration>,
            required: true,
        },
        providerData: {
            type: Object as PropType<IntegrationProviderDataType>,
            required: true,
        },
    })
</script>
